import { render, staticRenderFns } from "./AcceptEditDialog.vue?vue&type=template&id=6435e005&scoped=true"
import script from "./AcceptEditDialog.vue?vue&type=script&lang=js"
export * from "./AcceptEditDialog.vue?vue&type=script&lang=js"
import style0 from "./AcceptEditDialog.vue?vue&type=style&index=0&id=6435e005&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6435e005",
  null
  
)

export default component.exports